export default __webpack_public_path__ + "static/assets/med_pill_triangle_flat_L1_solid_x_01_f_mask.a5e0582c.png";